
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cloud",
      function () {
        return require("private-next-pages/cloud/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cloud"])
      });
    }
  